import React from "react";
import classNames from "classnames";
import { IconProps } from "../type";

export const SessionColorIcon = ({ className, style, ...props }: IconProps) => (
  <svg
    className={classNames(["h-full w-full", className])}
    style={style}
    {...props}
    viewBox='0 0 42 43'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M20.0347 9.93376C17.4478 9.21302 16.1625 7.04453 16.5197 4.75738C16.9357 2.13422 19.2316 0.878848 21.1302 0.943802C23.28 1.0175 25.1699 2.59764 25.4822 4.78861C25.8219 7.16195 24.4117 9.27922 22.0821 9.93501C22.7803 9.93501 23.4786 9.93501 24.1768 9.93501C26.489 9.95375 28.4926 11.9648 28.5076 14.2845C28.5138 15.4374 28.5188 16.5904 28.5076 17.7433C28.4996 17.881 28.529 18.0183 28.5928 18.1406C28.6566 18.2629 28.7523 18.3656 28.8698 18.4378C32.1763 20.8724 34.1099 24.1388 34.4622 28.2222C34.7707 31.6046 33.7903 34.9788 31.7174 37.6692C29.6444 40.3597 26.6317 42.168 23.2825 42.7321C16.0038 43.9375 9.05868 39.2208 7.75209 31.9896C6.75279 26.4535 8.62648 21.9104 13.0909 18.4703C13.225 18.3831 13.3334 18.2616 13.4048 18.1184C13.4762 17.9752 13.508 17.8155 13.4968 17.6559C13.4781 16.5504 13.4856 15.4437 13.4906 14.3369C13.5049 13.1713 13.9748 12.0575 14.7998 11.2339C15.6248 10.4103 16.7393 9.94233 17.905 9.93002C18.5758 9.93126 19.2403 9.93376 20.0347 9.93376ZM10.5614 29.4301C10.6975 35.3185 15.2256 39.8253 21.0016 39.8216C26.8312 39.8216 31.403 35.2448 31.4043 29.4201C31.4043 23.523 26.7575 18.9774 20.9678 19.0062C15.0295 19.0361 10.6626 23.7041 10.5614 29.4301ZM21.0016 12.9904C20.0985 12.9904 19.1966 12.9841 18.2947 12.9904C17.1393 13.0004 16.5534 13.5949 16.5459 14.7579C16.5459 15.2401 16.5597 15.7222 16.5397 16.2044C16.526 16.5416 16.6021 16.6416 16.9606 16.5291C18.1303 16.1521 19.3473 15.9419 20.5756 15.9046C22.0839 15.8575 23.5892 16.0666 25.0275 16.5229C25.3635 16.6316 25.4747 16.5716 25.4585 16.2106C25.436 15.711 25.4585 15.2113 25.451 14.7179C25.4335 13.5937 24.8389 13.0004 23.7022 12.9891C22.8053 12.9829 21.9034 12.9904 21.0016 12.9904ZM21.0016 4.03414C20.6252 4.04724 20.2676 4.20152 19.9998 4.4663C19.732 4.73107 19.5737 5.08695 19.5563 5.46314C19.5438 6.21262 20.2146 6.89839 20.9741 6.92087C21.7336 6.94336 22.4493 6.23635 22.4418 5.46814C22.4263 5.09104 22.2692 4.73366 22.0017 4.46737C21.7343 4.20108 21.3762 4.04548 20.9991 4.03164L21.0016 4.03414Z'
      fill='url(#paint0_linear_1565_22822)'
    />
    <path
      d='M4.46128 35.4329C4.22085 35.4343 3.98408 35.3739 3.77367 35.2576C3.56326 35.1412 3.38626 34.9728 3.25962 34.7684C2.26032 33.2819 1.26102 31.7942 0.281707 30.2978C-0.105522 29.7069 -0.0930313 29.0886 0.299194 28.499C1.26977 27.0313 2.24034 25.5648 3.2259 24.1071C3.73804 23.3501 4.67738 23.1627 5.40063 23.6412C6.12387 24.1196 6.295 25.0577 5.7966 25.8284C5.10209 26.9001 4.39425 27.9623 3.67309 29.0149C3.47572 29.3022 3.46573 29.5145 3.66684 29.8056C4.40008 30.8698 5.11208 31.9478 5.81908 33.0296C5.98525 33.2685 6.07925 33.5501 6.08988 33.8408C6.10051 34.1316 6.02732 34.4193 5.87904 34.6697C5.59299 35.1918 5.12457 35.4367 4.46128 35.4329Z'
      fill='url(#paint1_linear_1565_22822)'
    />
    <path
      d='M37.5482 23.3951C37.7821 23.3937 38.0125 23.4521 38.2176 23.5647C38.4226 23.6773 38.5955 23.8403 38.7199 24.0384C39.7292 25.5374 40.736 27.0363 41.7241 28.5478C42.0988 29.1211 42.0851 29.7344 41.7078 30.3078C40.7323 31.7905 39.7517 33.2695 38.7536 34.7384C38.6419 34.9131 38.496 35.0635 38.3247 35.1805C38.1534 35.2975 37.9603 35.3787 37.7569 35.4193C37.5535 35.4599 37.344 35.459 37.1409 35.4167C36.9379 35.3744 36.7454 35.2915 36.5752 35.1731C35.8857 34.7072 35.7008 33.7679 36.1854 33.0196C36.8783 31.9479 37.5861 30.8857 38.309 29.8331C38.5163 29.5321 38.5313 29.3135 38.3177 29.0037C37.5895 27.9544 36.8912 26.8802 36.1942 25.8184C36.021 25.5752 35.923 25.2865 35.9121 24.9882C35.9012 24.6898 35.978 24.3948 36.133 24.1396C36.409 23.6449 36.8625 23.3951 37.5482 23.3951Z'
      fill='url(#paint2_linear_1565_22822)'
    />
    <path
      d='M18.7605 30.9409C18.011 30.9409 17.2615 30.9471 16.5195 30.9409C15.6102 30.9321 14.9844 30.3076 14.9831 29.4207C14.9819 28.5338 15.6002 27.8892 16.5058 27.8892C17.63 27.8805 18.7467 27.8767 19.8684 27.8892C20.0144 27.8956 20.1599 27.8697 20.2946 27.8134C20.4294 27.757 20.55 27.6716 20.6479 27.5632C21.8283 26.3666 23.0212 25.1836 24.2092 23.992C24.5002 23.6997 24.815 23.4536 25.2422 23.4036C25.9504 23.3199 26.5463 23.6147 26.8498 24.1943C27.0048 24.4776 27.0657 24.8029 27.0237 25.1231C26.9817 25.4433 26.839 25.7418 26.6162 25.9756C25.1173 27.5095 23.5883 29.0234 22.0632 30.5361C21.9233 30.6727 21.7569 30.7791 21.5743 30.8487C21.3916 30.9183 21.1967 30.9497 21.0014 30.9409C20.2544 30.9334 19.5075 30.9409 18.7605 30.9409Z'
      fill='url(#paint3_linear_1565_22822)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_1565_22822'
        x1='-0.00195313'
        y1='0.941406'
        x2='43.5368'
        y2='2.60313'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_1565_22822'
        x1='-0.00195313'
        y1='0.941406'
        x2='43.5368'
        y2='2.60313'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_1565_22822'
        x1='-0.00195313'
        y1='0.941406'
        x2='43.5368'
        y2='2.60313'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_1565_22822'
        x1='-0.00195313'
        y1='0.941406'
        x2='43.5368'
        y2='2.60313'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
    </defs>
  </svg>
);
